import React from 'react';
import { connect } from 'react-redux';
import { Backdrop } from '../../components/Themed.js';
import Captcha from '../../components/Captcha.js'
import { login } from '../../data/app/AppActions.js';
import { t } from '../../locales';
import './Login.scss';

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      recaptchaToken: null,
      isRecaptchaVerified: false,
      requestRecaptchaReset: false,
    };

    this.loginClick = this.loginClick.bind(this);
  }

  onRecaptchaTokenChanged(recaptchaToken) {
    this.setState({
      recaptchaToken
    })
  }

  onRecaptchaVerifiedChanged(isRecaptchaVerified) {
    this.setState({
      isRecaptchaVerified
    })
  }

  async loginClick(e) {
    e.preventDefault();

    const isOk = await this.props.login(this.state.email, this.state.password, this.state.recaptchaToken);
    if (!isOk) {
      this.setState({
        requestRecaptchaReset: !this.state.requestRecaptchaReset
      })
      return;
    }
  }

  render() {
    const {
      requestRecaptchaReset,
      isRecaptchaVerified
    } = this.state

    return (
      <div className="login-page guest-layout">
        <Backdrop />
        <div className="content-medium">
          <div className="title">{t('login_page.login')}</div>
          <form className="form">
            {this.props.loginError && (
              <div className="error">{this.props.loginError}</div>
            )}
            <div className="form-group">
              <div className="control-label">{t('login_page.email')}*</div>
              <input
                placeholder={t('login_page.email')}
                value={this.state.email}
                onChange={e => this.setState({ email: e.target.value })}
              />
            </div>
            <div className="form-group password">
              <div className="control-label">{t('login_page.password')}*</div>
              <input
                placeholder={t('login_page.password')}
                type="password"
                value={this.state.password}
                onChange={e => this.setState({ password: e.target.value })}
              />
            </div>
            <Captcha
              className="form-group"
              requestRecaptchaReset={requestRecaptchaReset}
              onRecaptchaTokenChanged={(value) => this.onRecaptchaTokenChanged(value)}
              onRecaptchaVerifiedChanged={(value) => this.onRecaptchaVerifiedChanged(value)}
            />
            <button onClick={this.loginClick} disabled={this.props.isLoggingIn || !isRecaptchaVerified}>
              {t('login_page.login')}
              {this.props.isLoggingIn ? (
                <React.Fragment>
                  &nbsp;
                  <i className="fas fa-spinner fa-pulse" />
                </React.Fragment>
              ) : (
                ''
              )}
            </button>
          </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isLoggingIn: state.app.isLoggingIn,
    loginError: state.app.loginError,
    authToken: state.app.authToken,
    businessInfo: state.app.businessInfo,
    locations: state.app.locations,
  };
}

export default connect(
  mapStateToProps,
  { login }
)(Login);
